import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import Response_Processing from "../../../layout/Others/Response_Processing";
import AdminSaveHeader from "../../../components/CommonComponents/AdminSaveHeader";
import FormContainer from "../../../components/CommonComponents/FormContainer";
import Wrapper from "../../../components/CommonComponents/Wrapper";
import MessageLabel from "../../../components/CommonComponents/MessageLabel";
import AdminSwitch from "../../../components/CommonComponents/AdminSwitch";
import LeftWrapper from "../../../components/CommonComponents/LeftWrapper";
import AdminCustomInput from "../../../components/CommonComponents/AdminCustomInput";
import RightWrapper from "../../../components/CommonComponents/RightWrapper";
import { toast } from "react-toastify";
import AdminBackNavigation from "../../../components/CommonComponents/AdminBackNavigation";
import MessageHeading from "../../../components/CommonComponents/MessageHeading";
import axios from "axios";
import FieldRenderer2 from "../../../CustomFields/FieldRenderer2";
import FieldRenderer from "../../../CustomFields/FieldRenderer";
import saveCustomFieldsStrict from "../../../CustomFields/saveCustomFieldsStrict";

const EditAdsCategories = (props) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [withOutRefresh, setWithoutRefresh] = useState(false)
  const [editUser, setEditUser] = useState({
    name: "",
    slug: "",
    status: null,
  });

  const access_token = localStorage.getItem("access_token");

  const headers = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + access_token,
    Accept: "application/json",
    "Access-Control-Allow-Origin": "*",
  };

  const getUser = async () => {
    try {
      setShowOverlay(true);
      const reqData = await fetch(
        `${process.env.REACT_APP_Baseurl}/admin/advertisement/categories-edit/${id}`,
        { headers: headers }
      );
      const resData = await reqData.json();
      if (resData.status === true) {
        var res = resData?.data;
        setEditUser(res);
        setShowOverlay(false);
      }
    } catch (error) {
      setShowOverlay(false);
      toast.error("Something went wrong while fetching data.");
    }
  };

  useEffect(() => {
    getUser();
  }, [id, withOutRefresh]);

  const handleInput = (e) => {
    const { name, value } = e.target;
    setEditUser((prevEditUser) => ({
      ...prevEditUser,
      [name]: value,
    }));

    setValidationMessagename("");
    setIsValidationHiddenname(true);

    setEditUser({ ...editUser, [e.target.name]: e.target.value });

    if (e.target.checked === true) {
      setEditUser({ ...editUser, [e.target.name]: e.target.value });
      setEditUser({ ...editUser, [e.target.id]: 1 });
      setEditUser({
        ...editUser,
        [e.target.name]: e.target.value,
        [e.target.name]: 1,
      });
    } else {
      setEditUser({ ...editUser, [e.target.name]: e.target.value });
      setEditUser({ ...editUser, [e.target.id]: 0 });
      setEditUser({ ...editUser, [e.target.name]: e.target.value });
    }
  };

  const [validationMessagename, setValidationMessagename] = useState("");
  const [isValidationHiddenname, setIsValidationHiddenname] = useState(true);

  const nameInputRef = useRef(null);

  const [processing, setProcessing] = useState(false);
  const [showOverlay, setShowOverlay] = useState(false);
  const [customFieldValues, setCustomFieldValues] = useState({});


  const handleUpdate = async (e) => {
    let focusInputRef = null;

    if (editUser?.name === "") {
      setValidationMessagename("Name cannot be empty.");
      setIsValidationHiddenname(false);
      focusInputRef = nameInputRef;
    }

    if (focusInputRef) {
      focusInputRef.current.focus();
      return;
    }

    e.preventDefault();

    const editInputvalue = {
      name: editUser?.name,
      slug: editUser?.slug,
      status: editUser?.status === 1 ? 1 : 0,
    };

    let firstApiStatus = false;
    let resultapi = null;
    let resultapifalse = null;
    let resjson = null;
    setProcessing(true);
    setShowOverlay(true);

    try {
      const res = await fetch(
        `${process.env.REACT_APP_Baseurl}/admin/advertisement/categories-update/${id}`,
        {
          method: "PATCH",
          headers: headers,
          body: JSON.stringify(editInputvalue),
        }
      );

      resjson = await res.json();

      if (resjson.status === true) {
        firstApiStatus = true;
        resultapi = resjson;
        // save custom field values (strict)
        try {
          await saveCustomFieldsStrict({ baseURL: process.env.REACT_APP_Baseurl, headers, entityType: 'ads_category', entityId: id, values: customFieldValues });

        } catch (e) {
          toast.error(e.message);
          setProcessing(false);
          setShowOverlay(false);
          return;
        }
        toast.success(resjson.message);
      } else if (resjson.status === false) {
        resultapifalse = resjson;
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error("Something went wrong while updating data.");
    }

    if (firstApiStatus) {
      setValidationMessagename("");
      props.setApiresponsealert(resultapi);
      props.setShowalert(true);
      setWithoutRefresh(prev => !prev)
      setShowOverlay(false);
    } else if (resultapifalse) {
      props.setApiresponsealert(resultapifalse);
      props.setShowalert(true);
      setProcessing(false);
      setShowOverlay(false);
      setIsValidationHiddenname(false);
    }
  };

  return (
    <>
      <AdminBackNavigation path="/ads_categories" text="Back" />
      {showOverlay && <Response_Processing></Response_Processing>}
      <AdminSaveHeader heading={"Edit Ads Category"} saveText={"Update"} saveMethod={handleUpdate} type="submit" />
      <FormContainer className="pb-5">
        <LeftWrapper>
          <Wrapper>
            <MessageHeading text={" "} />
            <MessageLabel text={"Name"} className="mandatorySimple" />
            <AdminCustomInput id="category_name" type="text" name="name" value={editUser.name} onChange={handleInput} placeHolder={"Enter Category Name"} ref={nameInputRef} />

            <MessageLabel text={"Slug"} />
            <AdminCustomInput id="category_slug" type="text" name="slug" value={editUser.slug} onChange={handleInput} placeHolder={"Enter Category Slug"} ref={nameInputRef} />

            <div className="card p-3 mt-3">
              <MessageHeading text="Additional Fields" />
              {/* Custom fields removed */}
              <FieldRenderer2
                pageIdentifier={"ads_category.edit"}
                entityType={"ads_category"}
                entityId={id}
                text="Additional Fields"
              />
              <FieldRenderer
                pageIdentifier={"ads_category.edit"}
                entityType={"ads_category"}
                entityId={id}
                onChange={setCustomFieldValues}
              />
            </div>


          </Wrapper>
        </LeftWrapper>

        <RightWrapper>
          <Wrapper>
            <MessageHeading text={"Status"} />
            <div className="d-flex justify-content-between mb-2 ">
              <div className="col-6 col-md-6 pe-2">
                <MessageLabel text={"Status"} />
              </div>
              <div className="col-6 col-md-6 ps-2 text-end">
                <AdminSwitch id="ads_category_status" name={'status'} checked={editUser?.status === 1} onChange={handleInput} />
              </div>
            </div>
          </Wrapper>
        </RightWrapper>
      </FormContainer>
    </>
  );
};

export default EditAdsCategories;